import React, { DetailedHTMLProps, LiHTMLAttributes, OlHTMLAttributes } from 'react';

import styled from 'styled-components';

export interface ListStyledProps extends DetailedHTMLProps<OlHTMLAttributes<HTMLOListElement>, HTMLOListElement> {
  styledProps: {
    isSubItem?: boolean;
  };
}

export const List = styled(({ styledProps, ...rest }: ListStyledProps) => <ol {...rest} />)`
  display: flex;
  list-style: none;
  width: 100%;
  height: ${({ styledProps }) => styledProps.isSubItem && '80px'};
  border-radius: ${({ styledProps }) => (styledProps.isSubItem ? '8px' : '36px')};
  padding: 4px;
  overflow-x: auto;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.switch.inactive.background};
`;

export interface ItemStyledProps extends DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement> {
  styledProps: {
    isActive: boolean;
    isSubItem?: boolean;
  };
}

export const Item = styled(({ styledProps, ...rest }: ItemStyledProps) => <li {...rest} />)`
  flex: 1;
  text-align: center;
  border-radius: ${({ styledProps }) => (styledProps.isSubItem ? '8px' : '36px')};
  padding: 15px 30px;
  font-weight: 600;
  user-select: none;
  white-space: nowrap;

  ${({ theme, styledProps }) => {
    if (styledProps.isActive) {
      return `
        background-image: linear-gradient(102deg, ${theme.switch.active.background}, ${theme.switch.active.background}) !important;

        & > span {
          font-size: 10px;
          color: ${theme.switch.active.color} !important;
        }
      `;
    }
    return `
        background-image: linear-gradient(102deg, ${theme.switch.inactive.background}, ${theme.switch.inactive.background});

        & > span {
          font-size: 10px;
          cursor: pointer;
          color: ${theme.switch.inactive.color};
        }
      `;
  }}
`;

export const SubItem = styled.span`
  font-size: 10px;
  line-height: 1.6;
  font-weight: normal;
`;
